import Tibbit39Node from '@appblocks/codegeneration/Nodes/Tibbit39Node';
import { Setting, SettingType } from '@appblocks/codegeneration/types';

export default class Tibbit39_3Node extends Tibbit39Node {
    constructor() {
        super();
        this.name = 'Tibbit 39_3';
        this.id = 'node_tibbit_39_3';
        this.linkedFeature = 'tibbit_39_3';
        this.description = 'Large yellow LED (low brightness)';

        const settings: Setting[] = [
            {
                id: 'TIBBIT',
                name: 'Tibbit',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'tibbit_39_3',
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }
}
